var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"sm:w-[50%] md:w-[34%] lg:w-[25%] channel",on:{"click":function($event){return _vm.$emit('click')}}},[_c('img',{attrs:{"src":_vm.src,"alt":_vm.title}}),_vm._v(" "),_c('h3',{staticClass:"channel__title"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")])])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }